import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
  addCartToLocalStorage,
  getCartFromLocalStorage,
} from "services/LocalStorage/LocalStorage.service";
import { getPromoCodeDiscountThunk } from "./cart.actions";
import { showToast } from "utils/helpers/toastHelper";
// import { toast } from 'react-toastify';

export const getPromoCodeDiscount = createAsyncThunk(
  "cart/getPromoCodeDiscount",
  getPromoCodeDiscountThunk
);

export const calculateDiscount = (price, discount) => {
  let discountPrice = price;
  discountPrice = discountPrice * (1 - discount / 100);
  let decimal = Math.round((discountPrice * 100) % 10);
  if (decimal < 5) {
    return discountPrice - decimal / 100;
  } else {
    return discountPrice - decimal / 100 + 0.05;
  }
};

export const cartInitialState =
  getCartFromLocalStorage() != null
    ? getCartFromLocalStorage()
    : {
        loading: false,
        list: [],
        meta: {},
        total_price: 0.0,
        total_count: 0,
        total_item_count: 0,
        total_discount: 0, //% popust ako ima neki kod ili na ukupno sve
        final_price: 0.0, //konacna cena sa popustom na sve
      };

const CartSlice = createSlice({
  name: "cart",
  initialState: cartInitialState,
  reducers: {
    addArticle: (state, { payload }) => {
      let old_price = parseFloat(payload.old_price);
      let discount = parseInt(payload.discount);
      let price = parseFloat(payload.price);
      const slug = payload.slug;
      const name = payload.name;
      const image = payload.image;
      let quantity = payload.quantity ? payload.quantity : 1;

      let total_add_price = price * quantity;

      let exist = false;
      state.list.forEach((item) => {
        if (item.slug === payload.slug) {
          item.old_price = old_price;
          item.discount = discount;
          item.price = price;
          // item.slug = slug;
          // item.name = name;
          // item.image = image;
          item.count += quantity;
          item.total_price = item.price * item.count;
          exist = true;
        }
      });

      if (!exist) {
        state.list.push({
          old_price: old_price,
          discount: discount,
          price: price,
          slug: slug,
          name: name,
          image: image,
          count: quantity,
          total_price: price * quantity,
        });
        state.total_item_count += 1;
      }
      state.total_price += total_add_price;
      state.total_count += quantity;
      // TODO trenutno nista
      if (state.total_discount !== 0) {
        state.final_price = calculateDiscount(
          state.total_price,
          state.total_discount
        );
      } else {
        state.final_price = state.total_price;
      }

      addCartToLocalStorage(state);
    },
    removeArticle: (state, { payload }) => {
      //todo prilagoditi
      const index = state.list.findIndex(
        (item) => item.slug === payload.item_slug
      );
      if (index !== -1) {
        if (payload.all_items) {
          state.total_price -=
            state.list[index].price * state.list[index].count;
          state.total_count -= state.list[index].count;
          if (state.total_discount !== 0) {
            state.final_price = calculateDiscount(
              state.total_price,
              state.total_discount
            );
          } else {
            state.final_price = state.total_price;
          }
          state.list.splice(index, 1);
          state.total_item_count -= 1;
        } else {
          state.total_price -= state.list[index].price;
          state.total_count -= 1;
          if (state.total_discount !== 0) {
            state.final_price = calculateDiscount(
              state.total_price,
              state.total_discount
            );
          } else {
            state.final_price = state.total_price;
          }
          if (state.list[index].count === 1) {
            // brisanje elementa iz niza
            state.list.splice(index, 1);
            state.total_item_count -= 1;
          } else {
            state.list[index].count -= 1;
            state.list[index].total_price = state.list[index].price;
          }
        }
        if (state.list.length === 0) {
          state.total_discount = 0;
        }
      }
      addCartToLocalStorage(state);
    },
    calculateCart: (state) => {
      state.final_price = calculateDiscount(
        state.total_price,
        state.total_discount
      );
    },
    resetCart: (state) => {
      // Resetovanje pojedinačnih delova state-a
      state.loading = false;
      state.list = [];
      state.meta = {};
      state.total_price = 0.0;
      state.total_count = 0;
      state.total_item_count = 0;
      state.total_discount = 0;
      state.final_price = 0.0;

      // Snimanje resetovanog state-a u lokalni storage
      addCartToLocalStorage(state);
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getPromoCodeDiscount.fulfilled, (state, { payload }) => {
        return { ...state, total_discount: payload };
      })
      .addCase(getPromoCodeDiscount.rejected, (state, { payload }) => {
        showToast(payload.message, "error");
        return { ...state, total_discount: 0 };
      });
  },
});

export const { addArticle, removeArticle, resetCart, calculateCart } =
  CartSlice.actions;
export default CartSlice.reducer;
